import { api } from '@setplex/tria-api'
import { attach, sample } from 'effector'
import { and } from 'patronum'
import type { SendEventParams } from '~/shared/analytix'
import { logErrorFx } from '../lib'
import { $readyAllInfo } from '../session/model'
import { $analytix, $analytixEnabled } from '../wrapper'

const $searchEventCanBeSent = and($readyAllInfo, $analytixEnabled)

export const sendSearchFx = attach({
  source: $analytix,
  effect: (analytix, params: SendEventParams.Search) =>
    analytix.sendSearchEvent(params),
})

sample({
  clock: sendSearchFx.failData,
  fn: (e) => e,
  target: logErrorFx,
})

/** Mirrors legacy OVP `searchBase.getFx` → `sendAnalyticsSearch` (global search). */
sample({
  clock: api.search.base.getFx,
  source: $searchEventCanBeSent,
  filter: Boolean,
  fn: (_, params: { q: string; limit?: number }) => ({
    query: params.q ?? '',
    searchType: 'globalSearch',
  }),
  target: sendSearchFx,
})
